import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { countries, devConfig, profile } from 'config/config'; // Importing configuration data

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Text input for User ID
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            minWidth: 200,
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Custom template for country options
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'radio', // Radio buttons for type selection
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width > 500 ? 0 : 100,
                            value: 0,
                            options: [
                                { id: 0, value: _('Detallado') },
                                { id: 1, value: _('Totales') },
                            ],
                        },
                        {
                            view: 'radio', // Radio buttons for negative balances selection
                            name: 'NegativeBalances',
                            id: 'NegativeBalances',
                            label: _('Solo Saldos Negativos'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width > 500 ? 0 : 100,
                            value: 1,
                            options: [
                                { id: 0, value: _('Sí') },
                                { id: 1, value: _('No') },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Adding left section to upper section
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const currentDate = $$('Datepicker').getValue(); // save current date
                                this.getRoot().clear(); // Clear form values
                                $$('Datepicker').setValue(currentDate); // deafault date
                                $$('Type').setValue(0);
                                $$('NegativeBalances').setValue(1); // Reset NegativeBalances radio button
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                 if (filterdata.Datepicker) {
                                    const parts = String(filterdata.Datepicker).split(' - ');
                                    const from = parts[0];
                                    const to = parts[1] || parts[0];
                                    filterdata.FromDateLocal = from;
                                    filterdata.ToDateLocal = to;
                                    delete filterdata.Datepicker;
                                }

                                this.app.callEvent(
                                    'balanceAdjustments:filter',
                                    [filterdata], // Trigger filter event with data
                                );
                                $$('b5').collapse(); // Collapse the accordion
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to clear second form
                            value: _('Limpiar'),
                            click: () => {
                                const currentDate = $$('Datepicker').getValue(); // save current date
                                $$('myForm2').clear(); // Clear second form values
                                $$('Type').setValue(0); // Reset Type radio button
                                $$('Datepicker').setValue(currentDate); // deafault date
                                $$('NegativeBalances').setValue(1); // Reset NegativeBalances radio button
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data from second form
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get second form values
                                 if (filterdata.Datepicker) {
                                    const parts = String(filterdata.Datepicker).split(' - ');
                                    const from = parts[0];
                                    const to = parts[1] || parts[0];
                                    filterdata.FromDateLocal = from;
                                    filterdata.ToDateLocal = to;
                                    delete filterdata.Datepicker;
                                }
                                
                                this.app.callEvent(
                                    'balanceAdjustments:filter',
                                    [filterdata], // Trigger filter event with data
                                );
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Include accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section if screen size is adequate
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }
     init() {
        const lang = this.app.getService('locale').getLang();
        webix.ready(function () {
            $$('Datepicker').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang);
            });
        });
    }
}

// FILE DOCUMENTED
